goog.provide("shadow.js.shim.module$src$svg$wpp$content$calendar_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$calendar_svg");
shadow.js.shim.module$src$svg$wpp$content$calendar_svg = shadow.js.nativeProvides["src/svg/wpp/content/calendar.svg"] = shadow$bridge("src/svg/wpp/content/calendar.svg");
module$shadow_js_shim_module$src$svg$wpp$content$calendar_svg.default = shadow.js.shim.module$src$svg$wpp$content$calendar_svg;
